module.exports = __webpack_public_path__ + "img/mcwhirterr.f57b39bf.jpg";